// Globally disable browser's automatic scroll restoration as early as possible to prevent layout shifts
if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

exports.onClientEntry = () => {
  if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
};

exports.onInitialClientRender = () => {
  if (typeof window === 'undefined') {
    return;
  }

  // Fix: after a hard refresh on another route (e.g. /workstation), using the browser Back button
  // can restore the previous page from the back/forward cache (bfcache). Gatsby sometimes ends up
  // rendering the dev-404 UI even when the URL is `/`. If we detect a bfcache restore, do a clean
  // reload so Gatsby bootstraps normally.
  window.addEventListener('pageshow', event => {
    const navEntry =
      typeof performance !== 'undefined' && typeof performance.getEntriesByType === 'function'
        ? performance.getEntriesByType('navigation')[0]
        : null;
    const isBackForward = navEntry && navEntry.type === 'back_forward';

    if (event.persisted || isBackForward) {
      window.location.reload();
    }
  });

  // If the browser ever lands on the offline plugin's internal URL, bounce back home.
  if (window.location.pathname.startsWith('/.gatsby-plugin-offline:api=')) {
    window.location.replace('/');
    return;
  }

  // Unregister any previously-installed gatsby-plugin-offline service workers.
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(reg => {
        const scriptURL =
          (reg.active && reg.active.scriptURL) ||
          (reg.waiting && reg.waiting.scriptURL) ||
          (reg.installing && reg.installing.scriptURL) ||
          '';

        if (scriptURL.includes('gatsby-plugin-offline') || scriptURL.endsWith('/sw.js')) {
          reg.unregister();
        }
      });
    });
  }

  // Best-effort cache cleanup (helps prevent old offline HTML from resurfacing).
  if ('caches' in window) {
    caches.keys().then(keys => {
      keys
        .filter(k => k.toLowerCase().includes('workbox') || k.toLowerCase().includes('gatsby'))
        .forEach(k => caches.delete(k));
    });
  }
};
